<div>
  <div class="custom-tabs" role="tablist">
    <button class="custom-tab" [class.active]="activeTab === 2" (click)="activeTab = 2" role="tab">
      <span class="material-icons" style="vertical-align:middle;">group</span> Leads
    </button>
    <button class="custom-tab" [class.active]="activeTab === 1" (click)="activeTab = 1" role="tab">
      <span class="material-icons" style="vertical-align:middle;">restaurant_menu</span> Food Menu
    </button>
    <button class="custom-tab" [class.active]="activeTab === 0" (click)="activeTab = 0" role="tab">
      <span class="material-icons" style="vertical-align:middle;">fastfood</span> Food Type
    </button>
    <button class="custom-tab" [class.active]="activeTab === 3" (click)="activeTab = 3" role="tab">
      <span class="material-icons" style="vertical-align:middle;">events</span> Events
    </button>
  </div>
  <div class="tab-content" [class.active]="activeTab === 0">
    <div style="padding: 1.5rem;">
      <div *ngIf="loading">Loading...</div>
      <div *ngIf="error" style="color:red;">{{error}}</div>
      <div *ngIf="success" style="color: green;">Entry added/deleted</div>
      <div *ngIf="error" style="color: red;">{{error}}</div>
      <table *ngIf="!loading && !error">
        <thead>
          <tr>
            <th (click)="sortTable('order')" style="width: 50px;">Order
              <span *ngIf="sortColumn === 'order'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th>Image</th>
            <th>Tagline</th>
            <th>Text</th>
            <th>Actions</th>
          </tr>
          <tr>
            <!-- Order -->
            <td>
              <input type="number" [(ngModel)]="newFoodType.order" placeholder="Order" name="order" required>
            </td>
            <!-- Image -->
            <td>
              <input type="text" [(ngModel)]="newFoodType.image" placeholder="Image URL" name="image" required>
            </td>
            <!-- Tagline -->
            <td>
              <input type="text" [(ngModel)]="newFoodType.tagline" placeholder="Tagline" name="tagline" required>
            </td>
            <!-- Text -->
            <td>
              <input type="text" [(ngModel)]="newFoodType.text" placeholder="Text" name="text" required>
            </td>
            <td>
              <button type="button" (click)="onSubmitFoodType()" class="buttonNormal"
                [disabled]="!newFoodType.order || !newFoodType.image || !newFoodType.tagline || !newFoodType.text">
                Add
              </button>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let foodType of FoodType; let i = index">
            <ng-container *ngIf="editIndex === i; else displayRow">
              <!-- Edit Mode -->
              <td>
                <input type="number" [(ngModel)]="editRow.order" />
              </td>
              <td>
                <select [(ngModel)]="editRow.image">
                  <option *ngFor="let url of imageOptions" [value]="url">{{ url }}</option>
                </select>
              </td>
              <td>
                <input type="text" [(ngModel)]="editRow.tagline" />
              </td>
              <td>
                <input type="text" [(ngModel)]="editRow.text" />
              </td>
              <td>
                <button type="button" (click)="saveFTEdit(i)" class="buttonNormal">Save</button>
                <button type="button" (click)="cancelEditFT()" class="buttonNormal">Cancel</button>
              </td>
            </ng-container>
            <ng-template #displayRow>
              <!-- Display Mode -->
              <td>{{foodType.order}}</td>
              <td>
                <img *ngIf="foodType.image" [src]="foodType.image" alt="" style="height:40px;max-width:80px;">
              </td>
              <td>{{foodType.tagline}}</td>
              <td>{{foodType.text}}</td>
              <td>
                <button type="button" class="buttonNormal" (click)="deleteFoodType(foodType)">Delete</button>
                <button type="button" class="buttonNormal" (click)="editFoodType(i, foodType)">Edit</button>
              </td>
            </ng-template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="tab-content" [class.active]="activeTab === 1">
    <div style="padding: 1.5rem;">
      <div *ngIf="loading">Loading...</div>
      <div *ngIf="error" style="color:red;">{{error}}</div>
      <div *ngIf="success" style="color: green;">Entry added/deleted</div>
      <div *ngIf="error" style="color: red;">{{error}}</div>
      <table *ngIf="!loading && !error">
        <thead>
          <tr>
            <th (click)="sortTable('foodtype')">Item Type
              <span *ngIf="sortColumn === 'foodtype'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th>Item Type Tagline</th>
            <th>Item Type Image URL</th>
            <th>Food Name</th>
            <th>Food Description</th>
            <th>Food Image URL</th>
            <th>Price</th>
            <th>Event Name</th>
            <th>Event Id</th>
            <th>Actions</th>
          </tr>
          <tr>
            <!-- Food Type Dropdown -->
            <td>
              <mat-select placeholder="Item Type" [(ngModel)]="newRow.foodtype" class="dropdown" name="foodtypeSelect"
                (selectionChange)="onFoodTypeChange($event.value)" required>
                <mat-option *ngFor="let type of FoodType" [value]="type.text" class="dropdown">
                  {{type.text}}
                </mat-option>
              </mat-select>
            </td>
            <!-- Tagline and Image autopopulate -->
            <td>
              <input type="text" [(ngModel)]="newRow.foodtypetagline" placeholder="Item Type Tagline" [readonly]="true">
            </td>
            <td>
              <input type="text" [(ngModel)]="newRow.foodtypeimage" placeholder="Item Type Image URL" [readonly]="true">
            </td>
            <!-- All other fields disabled until foodtype is selected -->
            <td>
              <input type="text" [(ngModel)]="newRow.foodname" placeholder="Food Name" [disabled]="!newRow.foodtype">
            </td>
            <td>
              <input type="text" [(ngModel)]="newRow.fooddesc" placeholder="Food Description"
                [disabled]="!newRow.foodtype">
            </td>
            <td>
              <input type="text" [(ngModel)]="newRow.foodimage" placeholder="Food Image URL"
                [disabled]="!newRow.foodtype">
            </td>
            <td>
              <input type="number" [(ngModel)]="newRow.priceperplate" placeholder="Price" [disabled]="!newRow.foodtype">
            </td>
            <td>
              <input type="text" [(ngModel)]="newRow.eventname" placeholder="Event Name" [disabled]="!newRow.foodtype">
            </td>
            <td>
              <input type="text" [(ngModel)]="newRow.eventid" placeholder="Event Id" [disabled]="!newRow.foodtype">
            </td>
            <td>
              <button type="button" class="buttonNormal" (click)="onSubmitFoodMenu()" [disabled]="!isNewRowValid()">Add</button>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of foodmenu; let i = index">
            <ng-container *ngIf="editRowIndex === i else displayRow">
              <!-- Edit Mode -->
              <td>
                <mat-select [(ngModel)]="editRow.foodtype" class="dropdown" name="editFoodtypeSelect"
                  (selectionChange)="onEditFoodTypeChange($event.value, i)" required>
                  <mat-option *ngFor="let type of FoodType" [value]="type.text" class="dropdown">
                    {{type.text}}
                  </mat-option>
                </mat-select>
              </td>
              <td>
                <input type="text" [(ngModel)]="editRow.foodtypetagline" placeholder="Item Type Tagline"
                  [readonly]="true">
              </td>
              <td>
                <input type="text" [(ngModel)]="editRow.foodtypeimage" placeholder="Item Type Image URL"
                  [readonly]="true">
              </td>
              <td>
                <input type="text" [(ngModel)]="editRow.foodname" placeholder="Food Name">
              </td>
              <td>
                <input type="text" [(ngModel)]="editRow.fooddesc" placeholder="Food Description">
              </td>
              <td>
                <input type="text" [(ngModel)]="editRow.foodimage" placeholder="Food Image URL">
              </td>
              <td>
                <input type="number" [(ngModel)]="editRow.priceperplate" placeholder="Price">
              </td>
              <td>
                <!-- <input type="text" [(ngModel)]="editRow.eventname" placeholder="Event Name"> -->
                   <mat-select [(ngModel)]="editRow.eventname" class="dropdown" name="editEvent"
                  (selectionChange)="onEventChange($event.value, i)" required>
                  <mat-option *ngFor="let event of events" [value]="event.EventName" class="dropdown">
                    {{event.EventName}}
                  </mat-option>
                </mat-select>

              </td>
              <td>
                <input type="text" [(ngModel)]="editRow.eventid" placeholder="Event Id" [readonly]="true">
              </td>
              <td>
                <button type="button" (click)="saveMenuItem(i)" class="buttonNormal">Save</button>
                <button type="button" (click)="cancelEditRow()" class="buttonNormal">Cancel</button>
              </td>
            </ng-container>
            <ng-template #displayRow>
              <!-- Display Mode -->
              <td>{{item.foodtype}}</td>
              <td>{{item.foodtypetagline}}</td>
              <td>
                <img *ngIf="item.foodtypeimage" [src]="item.foodtypeimage" alt="" style="height:40px;max-width:80px;">
              </td>
              <td>{{item.foodname}}</td>
              <td>{{item.fooddesc}}</td>
              <td>
                <img *ngIf="item.foodimage" [src]="item.foodimage" alt="" style="height:40px;max-width:80px;">
              </td>
              <td>{{item.priceperplate}}</td>
              <td>{{item.eventname}}</td>
              <td>{{item.eventid}}</td>
              <td style="width: 170px;">
                <button type="button" class="buttonNormal" (click)="deleteFoodItem(item)">Delete</button>
                <button type="button" class="buttonNormal" (click)="startEditRow(i)">Edit</button>
              </td>
            </ng-template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="tab-content" [class.active]="activeTab === 2">
  <div style="padding: 1.5rem;">
    <div *ngIf="loading">Loading...</div>
    <div *ngIf="error" style="color:red;">{{error}}</div>
    <div *ngIf="success" style="color: green;">Lead Updated</div>
    <div *ngIf="error" style="color: red;">{{error}}</div>
    <table *ngIf="!loading && !error">
      <thead>
        <tr>
          <th>
            Request Date
            <br>
            <input type="date" [(ngModel)]="filters.requestDate" (ngModelChange)="applyFilters()" style="width: 120px;">
          </th>
          <th>Customer Name</th>
          <th>Customer Phone</th>
          <th>
            Venue
            <br>
            <input type="text" [(ngModel)]="filters.venue" (ngModelChange)="applyFilters()" placeholder="Filter Venue" style="width: 120px;">
          </th>
          <th>
            Event
            <br>
            <input type="text" [(ngModel)]="filters.event" (ngModelChange)="applyFilters()" placeholder="Filter Event" style="width: 120px;">
          </th>
          <th>Event Date</th>
          <th>PAX</th>
          <th>Menu</th>
          <th>
            Contacted
            <br>
            <select [(ngModel)]="filters.contacted" (ngModelChange)="applyFilters()" style="width: 100px;">
              <option value="">All</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </th>
          <th>Comments</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of filteredLeads; let i = index">
          <td>{{toDDMMYYYY(item.requestdate)}}</td>
          <td>{{item.Name}}</td>
          <td>{{item.Phone}}</td>
          <td>{{item.Location}}</td>
          <td>{{item.event}}</td>
          <td>{{toDDMMYYYY(item.date)}}</td>
          <td>{{item.pax}}</td>
          <td>
            <table border="1">
              <thead>
                <tr>
                  <th *ngFor="let header of getHeaders(item.menu)">{{ header | titlecase }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of item.menu">
                  <td *ngFor="let header of getHeaders(item.menu)">
                    {{ row[header] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td [ngStyle]="{'background-color': (item.contacted?.toLowerCase() === 'yes') ? 'lightgreen' : ''}" style="text-align: center;">
            <ng-container *ngIf="editIndex === i; else displayContacted">
              <input [(ngModel)]="editedContacted" />
            </ng-container>
            <ng-template #displayContacted>{{item.contacted}}</ng-template>
          </td>
          <td>
            <ng-container *ngIf="editIndex === i; else displayComments">
              <input [(ngModel)]="editedComments" />
            </ng-container>
            <ng-template #displayComments>{{item.comments}}</ng-template>
          </td>
          <td style="width: 300px;">
            <ng-container *ngIf="editIndex === i; else editButton">
              <button type="button" class="buttonNormal" (click)="SaveLead(item, i)">Save</button>
              <button type="button" class="buttonNormal" (click)="CancelEdit()">Cancel</button>
            </ng-container>
            <ng-template #editButton>
              <button type="button" class="buttonNormal" (click)="EditLead(item, i)">Edit</button>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
  <div class="tab-content" [class.active]="activeTab === 3">
    <div style="padding: 1.5rem;">
      <div *ngIf="loading">Loading...</div>
      <div *ngIf="error" style="color:red;">{{error}}</div>
      <div *ngIf="success" style="color: green;">Entry added/deleted</div>
      <table *ngIf="!loading && !error">
        <thead>
          <tr>
            <th (click)="sortTable('EventId')">Event Id
              <span *ngIf="sortColumn === 'EventId'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th>Event Name</th>
            <th>Actions</th>
          </tr>
          <tr>
            <td>
              <input type="number" [(ngModel)]="newEvent.EventId" placeholder="EventId" name="EventId" required>
            </td>
            <td>
              <input type="text" [(ngModel)]="newEvent.EventName" placeholder="EventName" name="EventName" required>
            </td>
            <td>
              <button type="button" class="buttonNormal" (click)="onSubmitEvent()" [disabled]="!newEvent.EventId || !newEvent.EventName ">
                Add
              </button>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let event of events; let i = index">
            <td *ngIf="editEventIndex !== i">{{event.EventId}}</td>
            <td *ngIf="editEventIndex !== i">{{event.EventName}}</td>
            <td *ngIf="editEventIndex !== i">
              <button type="button" (click)="editEvent(i)" class="buttonNormal">Edit</button>
              <button type="button" (click)="deleteEvent(event)" class="buttonNormal">Delete</button>
            </td>
            <ng-container *ngIf="editEventIndex === i">
              <td>
                <input type="number" [(ngModel)]="editEventModel.EventId">
              </td>
              <td>
                <input type="text" [(ngModel)]="editEventModel.EventName">
              </td>
              <td>
                <button type="button" (click)="saveEdit(i)" class="buttonNormal">Save</button>
                <button type="button" (click)="cancelEdit()" class="buttonNormal">Cancel</button>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>